export default {
  SET_SELECTED_TASK_TYPE: "SET_SELECTED_TASK_TYPE",
  SET_SELECTED_ACTIVITIES: "SET_SELECTED_ACTIVITIES",
};
